<!-- Listado de documentos -->
<div *ngIf="hayEnvioMuestrasInspectorEx" class="row">
    <div class="col-md-12">
        <div class="card card-accent-success animated fadeIn">

            <div class="card-header-buscador">
                <i class="fa fa-file-text-o"></i> Listado de documentos
            </div>

            <div class="card-body-grid">

                <p-table #tableSearch autoLayout="true" [value]="documentosLaboratorioEx"
                            [columns]="cols" sortField="Fecha" sortOrder="-1"
                            styleClass="table table-responsive-sm table-striped table-sm table-0-marginbot"
                            [ngClass]="displayGridHidden(documentosLaboratorioEx)">

                    <ng-template pTemplate="header" let-columns>
                        <tr>
                            <th scope="col" *ngFor="let col of columns" [ngStyle]="{'display': col.display}" [pSortableColumn]="col.field">
                                {{col.header}}
                                <p-sortIcon *ngIf="col.field!=='Link'" [field]="col.field"></p-sortIcon>
                            </th>
                        </tr>
                    </ng-template>

                    <ng-template pTemplate="body" let-rowData let-columns="columns" let-expanded="expanded" let-rowIndex="rowIndex">
                        <tr>
                            <td *ngFor="let col of columns" [ngStyle]="{'display': col.display}">
                                <span *ngIf="(col.field!=='Link' && col.field!=='Fecha')">
                                    {{rowData[col.field]}}
                                </span>

                                <span *ngIf="col.field==='Fecha'">
                                    {{rowData[col.field] | date:'dd/MM/yyyy'}}
                                </span>

                                <div *ngIf="col.field==='Link'" class="btn-group">

                                    <div>
                                        <button (click)="onDownload(rowData)" type="button" title="Descargar documento"
                                                class="btn btn-sm">
                                            <span class="fa fa-download"></span>
                                        </button>
                                    </div>

                                    <div>
                                        <button (click)="onEdit(rowData)" type="button" title="Editar"
                                                class="btn btn-sm">
                                            <span class="fa fa-search"></span>
                                        </button>
                                    </div>

                                    <div *ngIf="esPerfilConsultasyLaboratorio && !envioMuestrasExCerrado">
                                        <button (click)="onRemove(rowData)" type="button" title="Eliminar"
                                                class="btn btn-sm btn-danger">
                                            <span class="fa fa-remove"></span>
                                        </button>
                                    </div>

                                </div>
                            </td>
                        </tr>
                    </ng-template>

                </p-table>

                <div *ngIf="numeroDocumentosEx === 0" class="empty-grid">
                    No hay documentos asociados al certificado
                </div>

            </div>

        </div>
    </div>
</div>
